<template>
  <v-container class="pa-1">
    <!-- <v-layout justify-space-around row>
      <v-flex>
        <v-card class="dashBlock">
          <p>Amount orders</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock">
          <p>Total Revenue</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock">
          <p>Total Transfer</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock">
          <p>Total promotion</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
    </v-layout> -->

    <v-layout row>
      <v-flex>
        <v-btn
          color="#FFD600"
          class="btnReport"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/sale_messenger_report'
          "
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>sale messenger report</span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
</style>

<script>
export default {
  computed: {},
};
</script>
